import React from "react";
import { SegmentedControl, SegmentedControlOption } from "../../components/Core/SegmentedControl";

/**
 * The three customer profile types. Maps to the backend fields
 * `privatePerson` and `corporateGroup` (mutually exclusive).
 */
export type CustomerProfileType = "COMPANY" | "CORPORATE_GROUP" | "PRIVATE";

export function getCustomerProfileType(customer?: {
	privatePerson?: boolean;
	corporateGroup?: { id: string };
}): CustomerProfileType {
	if (customer?.privatePerson) return "PRIVATE";
	if (customer?.corporateGroup) return "CORPORATE_GROUP";
	return "COMPANY";
}

const OPTIONS: SegmentedControlOption[] = [
	{ value: "COMPANY", label: "corporateGroup.customerTypeCompany" },
	{ value: "CORPORATE_GROUP", label: "corporateGroup.customerTypeCorporateGroup" },
	{ value: "PRIVATE", label: "IS_PRIVATE_PERSON" },
];

interface Props {
	value: CustomerProfileType;
	onChange: (value: CustomerProfileType) => void;
}

/**
 * The customer profile-type chooser — a thin domain wrapper around the generic
 * {@link SegmentedControl} primitive, supplying the three Origo customer types.
 */
const CustomerTypeSelector: React.FC<Props> = ({ value, onChange }) => (
	<SegmentedControl
		options={OPTIONS}
		value={value}
		onChange={(next) => onChange(next as CustomerProfileType)}
	/>
);

export default CustomerTypeSelector;
